import { AddEditOrderBreadcrumbSteps } from '@/models/add-edit-order-breadcrumb-steps.enum';
import { GaCheckoutStepNames, GaCustomEvents } from '@/models/ga-custom-events.enum';

export const addEditOrderStepEvent = {
  [AddEditOrderBreadcrumbSteps.productsModelsSelection]: {
    event: GaCustomEvents.CheckoutStep2,
    checkout_step_name: GaCheckoutStepNames.SelectModels,
  },
  [AddEditOrderBreadcrumbSteps.productsQuantities]: {
    event: GaCustomEvents.CheckoutStep3,
    checkout_step_name: GaCheckoutStepNames.AddQuantities,
  },
  [AddEditOrderBreadcrumbSteps.orderDetails]: {
    event: GaCustomEvents.CheckoutStep4,
    checkout_step_name: GaCheckoutStepNames.Review,
  },
};
